import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import Flex from 'components/common/Flex';
import SubtleBadge from 'components/common/SubtleBadge';

const NavbarVerticalMenuItem = ({ route, isCollapseParent, open }) => {
  return (
    <Flex alignItems="center" justifyContent="between" className="w-100">
      <Flex alignItems="center">
        {route.icon && (
          <span className="nav-link-icon">
            <FontAwesomeIcon icon={route.icon} />
          </span>
        )}
        <span className="nav-link-text ps-1">{route.label || route.name}</span>
        {route.badge && (
          <SubtleBadge pill bg={route.badge.type} className="ms-2">
            {route.badge.text}
          </SubtleBadge>
        )}
      </Flex>
      {/* collapse parent일 경우 indicator 표시 */}
      {isCollapseParent && (
        <FontAwesomeIcon
          icon={open ? faChevronDown : faChevronRight}
          className="ms-auto text-muted"
          size="sm"
        />
      )}
    </Flex>
  );
};

// prop-types
const routeShape = {
  active: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};
routeShape.children = PropTypes.arrayOf(PropTypes.shape(routeShape));
NavbarVerticalMenuItem.propTypes = {
  route: PropTypes.shape(routeShape).isRequired,
  isCollapseParent: PropTypes.bool,
  open: PropTypes.bool,
};

export default React.memo(NavbarVerticalMenuItem);
